import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const LinkOffIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M19.3756 16.5637L17.6783 14.8283C18.325 14.649 18.8527 14.3028 19.2614 13.7897C19.6701 13.2767 19.8745 12.6792 19.8745 11.9974C19.8745 11.1858 19.5903 10.4953 19.0221 9.92587C18.4539 9.35649 17.7639 9.0718 16.9522 9.0718H13.0359V6.79677H16.9462C18.3858 6.79677 19.6129 7.3041 20.6275 8.31875C21.6421 9.33338 22.1495 10.5605 22.1495 12C22.1495 12.97 21.9026 13.8649 21.409 14.6848C20.9153 15.5048 20.2375 16.131 19.3756 16.5637ZM15.8919 13.0479L13.8082 10.9522H16.0837V13.0479H15.8919ZM19.6685 22.6L1.33423 4.2658L2.8 2.80005L21.1343 21.1343L19.6685 22.6ZM10.9641 17.2033H7.0538C5.61424 17.2033 4.38714 16.696 3.3725 15.6814C2.35787 14.6667 1.85055 13.4396 1.85055 12C1.85055 10.8421 2.19358 9.80413 2.87963 8.8862C3.56568 7.96827 4.4587 7.34571 5.5587 7.01852L7.61195 9.0718H7.0538C6.2404 9.0718 5.54901 9.35649 4.97963 9.92587C4.41025 10.4953 4.12555 11.1866 4.12555 12C4.12555 12.8134 4.4105 13.5048 4.98038 14.0742C5.55026 14.6436 6.24226 14.9283 7.05638 14.9283H10.9641V17.2033ZM7.9163 13.0479V10.9522H9.5174L11.5881 13.0479H7.9163Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
